// landing.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './landing.css';

const LandingPage = () => {
  const [input, setInput] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleGetStarted = () => {
    navigate('/choose-us');
  };

  const handleTryNow = () => {
    navigate('/login');
  };

  return (
    <div className="container">
      <div className="hero-section">
        <div className="pre-heading">
          <span className="highlight-badge">
            <span className="pulse-dot"></span>
            Dating just got easier with AI
          </span>
        </div>
        
        <h1 className="heading">
          Master the Art of Texting<br/>
          <span className="gradient-text">Get More Dates</span>
        </h1>
        
        <p className="subheading">
          Never stress about what to say again. Let our AI craft the perfect replies that get responses.
          <br className="desktop-break"/>
          <span className="highlight">50,000+ singles are getting 3x more dates using RizzologyGPT.</span>
        </p>
        
        <div className="social-proof">
          <span className="proof-item">
            <img src="/stars.svg" alt="rating" className="stars-icon"/>
            4.9/5 from 2,000+ reviews
          </span>
          <span className="proof-item">
            <span className="crown-icon">👑</span>
            #1 AI Dating Assistant
          </span>
        </div>
        
        <div className="cta-buttons-mobile">
          <button className="cta-button primary-cta" onClick={handleGetStarted}>
            Get Started <span className="arrow">→</span>
          </button>
          <button className="cta-button secondary-cta" onClick={handleTryNow}>
            Try Now
          </button>
        </div>
      </div>

      <div className="demo-section">
        <div className="success-stats">
          <div className="stat-item">
            <div className="stat-number">3x</div>
            <div className="stat-label">More Responses</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">89%</div>
            <div className="stat-label">Success Rate</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">10s</div>
            <div className="stat-label">Response Time</div>
          </div>
        </div>

        <div className="cta-container">
          <div className="limited-offer">
            <span className="pulse-dot"></span>
            <span>Limited Time Offer - 50% Off</span>
          </div>
          
          <button className="cta-button" onClick={handleGetStarted}>
            Get Started Now <span className="arrow">→</span>
          </button>
          
          <p className="money-back">30-Day Money-Back Guarantee</p>
        </div>
        
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">⚡️</div>
            <span>AI Reply in 10 Seconds</span>
          </div>
          <div className="feature-item">
            <div className="feature-icon">🎯</div>
            <span>Personality-Matched</span>
          </div>
          <div className="feature-item">
            <div className="feature-icon">🔒</div>
            <span>100% Private & Secure</span>
          </div>
          <div className="feature-item">
            <div className="feature-icon">💫</div>
            <span>24/7 AI Availability</span>
          </div>
        </div>
      </div>

      <div className="social-proof-section">
        <div className="testimonial">
          <div className="testimonial-content">
            <p>"RizzologyGPT helped me land my dream date. The responses were so natural and matched my style perfectly!"</p>
          </div>
          <div className="testimonial-author">
            <div className="author-avatar">MJ</div>
            <div className="author-info">
              <div className="author-name">Michael J.</div>
              <div className="stars">⭐⭐⭐⭐⭐</div>
            </div>
          </div>
        </div>
      </div>

      <div className="trust-badges">
        <p className="guarantee">100% satisfaction guaranteed • Cancel anytime</p>
        <div className="security-badges">
          <span>🔒 256-bit SSL Encryption</span>
          <span>🛡️ GDPR Compliant</span>
        </div>
      </div>
      
      <div className="sticky-cta">
        <button onClick={handleGetStarted}>
          Get 50% Off Now <span className="arrow">→</span>
        </button>
      </div>
    </div>
  );
}

export default LandingPage;
